<template>
  <v-dialog :value="value" width="500" persistent>
    <v-card>
      <v-card-title>Edit Non-Geo Number</v-card-title>

      <v-card-text>

        <BaseLabelAndInfo>
          <template #label>Number</template>
          <template #value>{{getNonGeoNumber.number}}</template>
        </BaseLabelAndInfo>

        <v-row>
          <v-col>
            <VSelect v-model="translateToNumber" :items="allProductNumbersForSelect" label="Translate to" hide-details dense outlined />
          </v-col>
        </v-row>

      </v-card-text>

      <v-divider />
      <v-card-actions>
        <v-spacer />

        <v-btn color="primary" small @click="submit" :disabled="disableSave" :loading="getTranslateNumberToLoading">SAVE</v-btn>
        <v-btn color="primary" small outlined @click="close" :disabled="disableSave">CLOSE</v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  import { mapGetters,mapActions } from 'vuex';

  export default {

    props: ['value'],

    computed: {
      ...mapGetters('numberTransfers',['getNonGeoNumber','getTranslateNumberTo','getTranslateNumberToError','getTranslateNumberToLoading']),
      ...mapGetters('products',['allProductNumbersForSelect']),

      disableSave(){
        return this.getTranslateNumberToLoading;
      },
    },

    data() {
      return {
        translateToNumber: '',
      }
    },

    watch: {
      value(val) {
        if(val){
          this.translateToNumber = this.getNonGeoNumber.translate_to_number_id;
        }
      }
    },

    methods: {

      ...mapActions('numberTransfers',['translateNumber']),

      async submit() {
        await this.translateNumber({
          nonGeoNumId: this.getNonGeoNumber.id,
          translateToId: this.translateToNumber,
          product_id: this.$route.params.id
        });
        if(!this.getTranslateNumberToError){
          this.$emit('translateComplete');
          this.close();
        }
      },

      close() {
        this.$emit('input', false);
      },
    },

  }
</script>

<style lang="scss" scoped></style>
